import App from '@/App.vue'
import NotFound from '@/components/NotFound.vue'
import OrderSearch from '@/fengyiLookOrder/orderSearch.vue'
// 路由配置
const routes = [
  {
    path: '/',
    name: 'app',
    component: App,
    redirect: '/OrderSearch',
    meta: {
      title: '首页',
    },
  },
  {
    path: '/OrderSearch',
    name: 'OrderSearch',
    component: OrderSearch,
    meta: {
      mes: '订单查询',
    },
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    meta: {
      title: '找不到您访问的页面',
    },
  },
  {
    path: '*',
    redirect: '/404',
  },
]

export default routes
